var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"mychart",attrs:{"id":_vm.id,"data":_vm.data}})
}
var staticRenderFns = []

export { render, staticRenderFns }